import { passwordSchema } from '@/shared/lib/passwordSchema';

export const passwordValidate = (value: string): string | true => {
  const result = passwordSchema.safeParse(value);
  if (result.success) {
    return true;
  }
  return result.error.issues[0]?.message ?? 'Invalid password';
};
